import React, { useCallback, useState, useMemo, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import dayjs from 'dayjs';
import qs from 'qs';
import * as apis from '@/apis';
import { Popover, Tag, Tooltip } from 'antd';
import QRCode from 'qrcode.react';
import { tenantsTransactionTypes, payMethodTypes } from '@/containers/finances/constants';
import Filters from './filter';
import PageableTable from '@/components/PageableTable';
import styles from './tenant_transactions.module.scss';

function useQuery(str) {
  return useMemo(() => qs.parse(str), [str]);
}

const columns = [
  {
    key: '_id',
    title: '交易类型',
    render: (item) => {
      if (item.type === 'tenant/balance_recharge' && !item.isPaid) {
        return (
          <>
            {tenantsTransactionTypes[item.type]}
            <Popover
              content={
                <div>
                  <QRCode
                    value={`https://api.xiaobingsubang.com/transactions/${item._id}/precreate`}
                  />
                </div>
              }
              trigger="click"
              title="扫码支付"
            >
              <div
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}
              >
                <Tag
                  color="#87d068"
                  style={{ marginLeft: 12, cursor: 'pointer' }}
                >
                  待支付
                </Tag>
                <i style={{ fontSize: 14, marginLeft: 0 }} className="iconfont">
                  &#xe600;
                </i>
              </div>
            </Popover>
          </>
        );
      }

      return (
        <Tooltip
          title={item.title + (item.paid_memo ? '  : ' + item.paid_memo : '')}
        >
          {tenantsTransactionTypes[item.type] || `未知类型${item.type}`}
        </Tooltip>
      );
    },
  },
  {
    title: '交易金额',
    render: (item) => (
      <div>
        <span>¥{item.amount?.toFixed(2)}</span>
        <span>{payMethodTypes[item?.pay_method] || ''}</span>
      </div>
    ),
  },
  {
    title: '余额',
    render: (item) => (
      <div>
        <span>¥{item.balance?.toFixed(2)}</span>
      </div>
    ),
  },
  {
    title: '剩余信用',
    render: (item) => (
      <div>
        <span>¥{item.credit?.toFixed(2)}</span>
      </div>
    ),
  },
  {
    title: '工单',
    render: (item) =>
      item.order?.order_no ? (
        <span>
          {item.order.order_no}
          {item.order.payer_type === 2 && (
            <span style={{ paddingLeft: 5 }}>
              <Tag>保外</Tag>
            </span>
          )}
        </span>
      ) : (
        '-'
      ),
  },
  {
    title: '派单人',
    render: (item) => item.order?.createdBy?.name || '',
  },
  {
    title: '服务类型',
    render: (item) => item?.order?.product_list.length > 0 ? { 1: '安装', 2: '维修' }[item?.order?.product_list[0]["service_type"]] : "",
  },
  {
    title: '备注',
    render: (item) => item?.order?.tenant_memo?.map((item) => item.memo).join('\n') || '',
  },
  {
    title: '交易时间',
    render: (item) => dayjs(item.createdAt).format('YYYY-MM-DD HH:mm:ss'),
  },
];

// 某个企业的 所有 交易记录
export default function TenantTransactions(props) {
  const history = useHistory();
  const location = useLocation();
  const query = useQuery(location.search.slice(1));
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [list, setList] = useState([]);
  const limit = 10;
  const pagination = {
    showTotal: (total) => `共计 ${total}条 记录`,
    showQuickJumper: true,
  };
  const fetch = useCallback(() => {
    setLoading(true);

    apis
      .getTransactions({ ...query, limit })
      .then((result) => {
        setTotal(result.total);
        setList(result.data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [query]);
  const navigateTo = useCallback(
    (param) => {
      window.scrollTop = 0;
      history.push(`/finances?${qs.stringify(param)}`);
    },
    [query]
  );
  const filterOnChange = useCallback((param) => {
    navigateTo({ ...param, offset: 0 });
  }, []);
  const handleTableChange = useCallback(
    (param) => {
      navigateTo({ ...query, ...param });
    },
    [query]
  );

  useEffect(() => {
    fetch();
  }, [location.search]);

  return (
    <div className={styles.wrap}>
      <Filters query={query} onChange={filterOnChange} />
      <PageableTable
        size="middle"
        className={styles.table}
        columns={columns}
        pagination={pagination}
        dataSource={list}
        loading={loading}
        total={total}
        limit={limit}
        offset={+query.offset || 0}
        onChange={handleTableChange}
      />
    </div>
  );
}
